import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { visitsApi } from '@/features/visits/api/lib/visits';
import { ApiError } from '@/types/interfaces/api-error';
import { useTranslation } from 'react-i18next';
import { VisitorNotificationMethod } from '../../api/types/visits';

export const useResendVisitorInvitation = (onSuccess?: () => void) => {
  const { t } = useTranslation(['visit']);

  return useMutation({
    mutationFn: ({ visitorId, method }: { visitorId: number; method: VisitorNotificationMethod }) =>
      visitsApi.resendVisitorInvitation(visitorId, method),
    onSuccess: () => {
      toast.success(t('visit:resendInvitation.success'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
